import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { LIKERT_OPTIONS } from "@/components/saboteur/saboteurData";

export default function SaboteurQuestion({ question, questionIndex, total, onAnswer }) {
  const [selected, setSelected] = useState(null);
  const hasAnswered = useRef(false);

  useEffect(() => {
    hasAnswered.current = false;
    setSelected(null);
  }, [question?.id]);

  function handleSelect(value) {
    if (hasAnswered.current) return;
    hasAnswered.current = true;
    setSelected(value);
    setTimeout(() => onAnswer(question.id, value), 300);
  }

  const progress = (questionIndex / total) * 100;

  return (
    <motion.div
      key={question.id}
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -40 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col items-center justify-center py-8 px-2"
    >
      <div className="max-w-xl w-full">
        {/* Progress */}
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs font-medium" style={{ color: "#99A6AB" }}>
            Teste de Sabotadores
          </span>
          <span className="text-xs font-medium" style={{ color: "#99A6AB" }}>
            {questionIndex + 1} / {total}
          </span>
        </div>
        <div className="w-full h-1.5 rounded-full mb-8" style={{ background: "#E5E9EA" }}>
          <motion.div
            className="h-full rounded-full"
            style={{ background: "#00DCA4" }}
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.4 }}
          />
        </div>

        {/* Question */}
        <h2 className="text-xl font-bold mb-8" style={{ fontFamily: "Poppins, sans-serif", color: "#003326" }}>
          {question.text}
        </h2>

        {/* Likert scale */}
        <div className="space-y-2.5">
          {LIKERT_OPTIONS.map((opt) => {
            const isSelected = selected === opt.value;
            return (
              <motion.button
                key={opt.value}
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                onClick={() => handleSelect(opt.value)}
                className="w-full text-left px-5 py-4 rounded-2xl transition-all duration-200 font-medium text-sm flex items-center gap-3"
                style={{
                  background: isSelected ? "#00DCA4" : "#ffffff",
                  color: isSelected ? "#003326" : "#2E3233",
                  border: isSelected ? "1.5px solid #00DCA4" : "1.5px solid #E5E9EA",
                }}
              >
                <div
                  className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold"
                  style={{
                    background: isSelected ? "rgba(0,51,38,0.2)" : "#F2F4F4",
                    color: isSelected ? "#003326" : "#99A6AB",
                  }}
                >
                  {opt.value}
                </div>
                <span>{opt.label}</span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
}
